import script from "./ReportsDialogView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsDialogView.vue?vue&type=script&setup=true&lang=js"

import "./ReportsDialogView.vue?vue&type=style&index=0&id=f8c533fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8c533fe"]])

export default __exports__